import * as firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/firestore'

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDR3hJ35qEpjROyoYY_ZeMTmtPsmTizV64",
    authDomain: "photo-gallery-app-50562.firebaseapp.com",
    projectId: "photo-gallery-app-50562",
    storageBucket: "photo-gallery-app-50562.appspot.com",
    messagingSenderId: "490941326200",
    appId: "1:490941326200:web:b4c91eac23220cff405e8d"
  };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };